import { GlobalStore } from "../store/global/GlobalStore";

export const useSelectedGuildRole = () => {
  const roles = GlobalStore.useState(s => s.userRoles);
  return roles[0];
};
